import tmppath from "./pathwaylistFeb2022test.json"

export const pathways=tmppath
